import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import PrintProvider, { NoPrint } from 'react-easy-print';
import App from './components/Kernel';
import configureStore from './configureStore';

const store = configureStore({});
persistStore(store, {

}, () => {
    ReactDOM.render(
        <PrintProvider>
            <NoPrint>
                <Provider store={store}>
                    <App store={store} />
                </Provider>
            </NoPrint>
        </PrintProvider>,
        document.getElementById('react'),
    );
});



//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 691
// module chunks = 0